import { render, staticRenderFns } from "./AdvEmptyCost.vue?vue&type=template&id=1021a707&scoped=true"
import script from "./AdvEmptyCost.vue?vue&type=script&lang=js"
export * from "./AdvEmptyCost.vue?vue&type=script&lang=js"
import style0 from "./AdvEmptyCost.vue?vue&type=style&index=0&id=1021a707&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1021a707",
  null
  
)

export default component.exports